import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Pending placeholder for the AdminDashboard → Segment route. Mirrors the view's
 * header (title + subtitle) and the dense segment table below it.
 */
export function AdminDashboardSegmentsSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-3">
      <div className="flex items-center justify-between gap-3">
        <div className="space-y-1">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-56" />
        </div>
        <Skeleton className="h-7 w-40 rounded-md" />
      </div>
      <Skeleton className="h-64 w-full rounded-md" />
    </div>
  );
}
